import create from "zustand";
import {isSmallDevice} from "../isSmallDevice";

export const useAppState = create<{
    sidebarOpen: boolean,
    setSidebarOpen: (value: boolean) => any,
}>((set, get) => ({
    sidebarOpen: !isSmallDevice,
    setSidebarOpen: (value: boolean) => set({ sidebarOpen: value })
}))